// extracted by mini-css-extract-plugin
export default {"container":"AppStoreButtons_container__GeAs1","button":"AppStoreButtons_button__QEfU5","badge":"AppStoreButtons_badge__21+sn"};